import { render, staticRenderFns } from "./newDocument.vue?vue&type=template&id=625ba050"
import script from "./newDocument.vue?vue&type=script&lang=js"
export * from "./newDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports